<template>
  <div class="btn-popup-container">
    <button class="btn-popup" type="button">
      <slot />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    notify: false,
    icon: '',
    redirect: '#',
  },
};
</script>

<style lang="scss">
.btn-popup-container {
  position: relative;
}
.btn-popup {
  background: #609;
  border-radius: 50px;
  border: 0;
  // padding: 12px 14px !important;
  width: 40px;
  height: 40px;
  transition: all 0.3s ease-in-out;

  &:hover {
    transform: scale(1.15);
    background: lighten(#609, 10%);
  }

  & img {
    height: 13px;
    width: 13px;
  }

  & span {
    font-family: 'VivoType';
    font-weight: 800;
    font-size: 14px;
    color: white;
  }
}
</style>
